import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import StoreImgCard from 'common/components/modules/store/store-image-card';
import StoreHelper from 'common/utils/store-helper.js';
import OptionsWraper from 'admin/views/store/modules/options-modal';
import '../style.scss';
import DateFormatter from 'common/utils/DateFormatter';
import { setShareModalAction as setShareModal } from 'admin/state/modules/common/actions';
import { MediaCardBottomView } from 'common/components/modules/media';
import { useDispatch } from 'react-redux';


const StorCard = ({
   data,
   isMobile,
   openDeleteConfirmModal,
   // onShare,
   publishDate,
   showTooltip,
   pinning,
   setIsOpenModal,
   is_pinned,
   endsDate,
   className,
   disabled,
   isSoldOut,
   isDemoMode,
   onClickOpenRepostModal,
   isInsideModal,
   onSelectItem,
   isChecked,
   isReorderMode,
}) => {
   const [openOptionsModal, setOpenOptionsModal] = useState(false);
   const [animate, setAnimate] = useState('up');
   const dispatch = useDispatch()

   const storStatus = {
      publish: {
         icon_name: 'public',
         name: 'Published',
      },
      unpublish: {
         icon_name: 'unpublish',
         name: 'Unpublished',
      },
      scheduled: {
         icon_name: 'clock',
         name: 'Scheduled',
         date: data.publish_date,
      },
      soldOut: {
         icon_name: 'sold-out',
         name: data?.label || 'Sold out',
         comment: data?.comment || '',
         date: data.publish_date,
      },
   }

   let status = 'scheduled'
   if(!data.is_future_publish_enabled) {
      status = !!data.active ? 'publish' : 'unpublish';
   }

   let statusKeyName = isSoldOut ? 'soldOut' : status

   useEffect(() => {
      if(isMobile) {
         setIsOpenModal(openOptionsModal)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [openOptionsModal])

   let timerFetching = null;
   function closeOrOpenModal(_bool) {
      let time = _bool ? 100 : 800
      if(!isMobile){
         time = 0
      }
      setAnimate(_bool ? 'up' : 'down');
      timerFetching = setTimeout(() => {
         setOpenOptionsModal(_bool);
      }, time);
   }

   useEffect(() => {
      return () => {
         clearTimeout(timerFetching);
      };
   }, [timerFetching]);

   let images = []
   if(!!data && !!data.image_full_src){
      images = [...JSON.parse((data && data?.image_full_src) && data?.image_full_src)]
   }
   let newImgArray = images.reduce((acum, val, index) => {
      acum.push({
         id: index,
         path: val,
      })
      return acum
   }, [])

   const showTimeFromNow = !!(status !== 'unpublish' && status !== 'scheduled' && !isSoldOut && Boolean(publishDate))

   const onShare = () => {
      dispatch(setShareModal({
         isOpen: true,
         additionalInfo: {
            contentType: 'store',
            contentId: data?.id,
            contentTitle: data?.name,
         },
      }))
   }


   return (
      <div
         role='presentation'
         onClick={ (e) => {
            if(!isInsideModal) return
            e.stopPropagation()
            e.preventDefault()
            onSelectItem()
         } }
         className={ `store-card rounded-lg relative  ${ className }` }>
         <StoreImgCard
            data={ data }
            src={ data?.image_full_src &&  JSON.parse(data.image_full_src)?.[0] }
            price={ StoreHelper.getStorePrice(data, true) }
            className='h-44 rounded-t-lg'
            status={ status }
            statusIcon={ storStatus[statusKeyName].icon_name }
            statusName={ storStatus[statusKeyName].name }
            statusDate={ storStatus[statusKeyName].date }
            isDetails={ false }
            newImgArray={ newImgArray }
            showBundleIcon={ true }
            hidePrice={ isInsideModal || data?.product_type === 'content_bundle_item' }
            endsDate={ endsDate }
            isSoldOut={ isSoldOut }
            comment={ storStatus[statusKeyName]?.comment || '' }
            isInsideModal={ isInsideModal }
            onSelectItem={ onSelectItem }
            isChecked={ isChecked }
            isReorderMode={ isReorderMode }
         />
         <MediaCardBottomView
            isPinned={ Boolean(is_pinned) }
            title={  data.name  }
            disabled={ disabled }
            showViews={ false }
            points={ !isInsideModal }
            onClickOptions={ (e) => {
               e.stopPropagation()
               e.preventDefault()
               clearTimeout(timerFetching);
               closeOrOpenModal(true)
            } }
            optionButtonClass={ `store-${ data.id }` }
            showTimeFromNow={ showTimeFromNow }
            statusName={ storStatus[statusKeyName].name }
            date={ publishDate }
            showDateTooltip={ showTooltip && !isSoldOut }
            showChooseInput={ isInsideModal }
            checked={ isChecked }
            isMultipleSelect
         />
         {
            openOptionsModal &&
            <OptionsWraper
               isMobile={ isMobile }
               id={ data.id }
               title={ data.name }
               animate={ animate }
               openClickDelete={ () => openDeleteConfirmModal({ id: data.id, name: data.name }) }
               closeModal={ () => {
                  clearTimeout(timerFetching);
                  closeOrOpenModal(false)
               } }
               onShare={ onShare }
               is_pinned={ is_pinned }
               pinning={ pinning }
               isDemoMode={ isDemoMode }
               onClickOpenRepostModal={ onClickOpenRepostModal }
               isPublished={ status === 'publish' }
               availableRepostDate={ !!data?.last_repost_date ? DateFormatter.getDiff(DateFormatter.addHoursToDate(data?.last_repost_date))?.days <= 1 ? DateFormatter.addHoursToDate(data?.last_repost_date) : null : null }
               showRepostButton={ data?.product_type === 'content_bundle_item' }
            />
         }
      </div>
   );
};

StorCard.propTypes = {
   data: PropTypes.object,
   isMobile: PropTypes.bool,
   openDeleteConfirmModal: PropTypes.func,
   // onShare: PropTypes.func,
   publishDate: PropTypes.string,
   showTooltip: PropTypes.bool,
   pinning: PropTypes.func,
   setIsOpenModal: PropTypes.func,
   is_pinned: PropTypes.bool,
   endsDate: PropTypes.string,
   className: PropTypes.string,
   disabled: PropTypes.bool,
   isSoldOut: PropTypes.bool,
   isDemoMode: PropTypes.bool,
   onClickOpenRepostModal: PropTypes.func,
   isInsideModal: PropTypes.func,
   onSelectItem: PropTypes.func,
   isChecked: PropTypes.bool,
   isReorderMode: PropTypes.bool,
};

StorCard.defaultProps = {
   showTooltip: false,
   pinning: () => {},
   setIsOpenModal: () => {},
   piis_pinnednned: false,
   endsDate: '',
   className: '',
   disabled: false,
   isSoldOut: false,
   isDemoMode: false,
   isInsideModal: false,
}

export default memo(StorCard);
